import { memo, useCallback } from 'react'

import { TaskTemplate } from '@crew/apis/taskTemplate/models/getTaskTemplates/response'
import { useTranslation } from '@crew/modules/i18n'

import { CrewConfirmDialog } from 'components/elements/crewConfirmDialog/crewConfirmDialog'
import { useModal } from 'components/layouts/modal/useModal'

import BaselineDelete from '~icons/ic/baseline-delete'
import BaselineCreate from '~icons/ic/baseline-create'

type TaskTemplateListItemProps = {
  target: TaskTemplate
  onEdit: (target: TaskTemplate) => void
  onDelete: (target: TaskTemplate) => void
}

// タスクテンプレートのリスト表示で、各行右端の「編集・削除」アイコンを表示するコンポーネント
export const TaskTemplateListItemActionButton = memo(
  (props: TaskTemplateListItemProps) => {
    const { t } = useTranslation()

    // 確認ダイアログのモーダル制御
    const [isConfirmDialogOpen, openConfirmDialog, closeConfirmDialog] =
      useModal()

    // 編集アイコン押下時の処理
    const handleEditIconClick = useCallback(() => {
      props.onEdit(props.target)
    }, [props])

    // 削除アイコン押下時の処理
    const handleDeleteIconClick = useCallback(() => {
      openConfirmDialog()
    }, [openConfirmDialog])

    // 確認ダイアログで削除確定ボタン押下時の処理
    const handleDeletePermitButtonClick = useCallback(() => {
      props.onDelete(props.target)
      closeConfirmDialog()
    }, [props, closeConfirmDialog])

    return (
      <div className="flex gap-2 pr-2 justify-end items-center">
        {/* 編集アイコン */}
        <span className="cursor-pointer" onClick={handleEditIconClick}>
          <BaselineCreate width={24} height={24} />
        </span>
        {/* 削除アイコン */}
        <span className="cursor-pointer" onClick={handleDeleteIconClick}>
          <BaselineDelete width={24} height={24} />
        </span>

        {/* 削除確認ダイアログ */}
        <CrewConfirmDialog
          isOpen={isConfirmDialogOpen}
          message={t('message.general.confirmMessage.delete')}
          onPermitButtonClick={handleDeletePermitButtonClick}
          onCancelButtonClick={closeConfirmDialog}
        />
      </div>
    )
  }
)
